import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader, PageHeader, ProgressBar } from "@/components/common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { NoBizCta } from "@/pages/Journey";
import { ChecklistRow } from "@/pages/Stage";

export default function Checklist() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  const [tools, setTools] = useState([]);
  useEffect(() => {
    api.get("/checklist").then((r) => setD(r.data)).catch(() => setErr(true));
    api.get("/tools").then((r) => setTools(r.data.tools)).catch(() => {});
  }, []);
  if (err) return <NoBizCta />;
  if (!d) return <Loader />;
  const update = (key, status) => setD((x) => {
    const fix = (i) => (i.key === key ? { ...i, status } : i);
    const next = { ...x, master: x.master.map((g) => ({ ...g, items: g.items.map(fix) })), stages: x.stages.map((s) => ({ ...s, items: s.items.map(fix) })) };
    next.done = next.stages.flatMap((s) => s.items).filter((i) => i.status === "completed").length;
    return next;
  });
  return (
    <div data-testid="checklist-page">
      <PageHeader eyebrow="Checklist" title="Master business checklist" subtitle={`${d.done} / ${d.total} completed`} />
      <ProgressBar value={(100 * d.done) / (d.total || 1)} tall className="mb-6" testid="checklist-progress" />
      <Tabs defaultValue="master">
        <TabsList className="bg-[#F5F0E6] rounded-xl">
          <TabsTrigger value="master" className="rounded-lg" data-testid="checklist-tab-master">Overview</TabsTrigger>
          <TabsTrigger value="stages" className="rounded-lg" data-testid="checklist-tab-stages">By stage</TabsTrigger>
        </TabsList>
        <TabsContent value="master" className="grid md:grid-cols-2 gap-4 mt-4">
          {d.master.map((g) => (
            <section key={g.title} className="sb-card p-5" data-testid={`master-group-${g.title}`}>
              <div className="flex justify-between"><div className="sb-eyebrow">{g.title}</div><span className="text-xs font-bold">{g.items.filter((i) => i.status === "completed").length}/{g.items.length}</span></div>
              <ul className="divide-y divide-[#EADEC9]">{g.items.map((i) => <ChecklistRow key={i.key} item={i} bizId={d.business_id} onChange={update} tools={tools} />)}</ul>
            </section>
          ))}
        </TabsContent>
        <TabsContent value="stages" className="space-y-4 mt-4">
          {d.stages.map((s) => (
            <section key={s.key} className="sb-card p-5">
              <div className="flex justify-between"><div className="sb-eyebrow">{s.name}</div><span className="text-xs font-bold">{s.items.filter((i) => i.status === "completed").length}/{s.items.length}</span></div>
              <ul className="divide-y divide-[#EADEC9]">{s.items.map((i) => <ChecklistRow key={i.key} item={i} bizId={d.business_id} onChange={update} tools={tools} />)}</ul>
            </section>
          ))}
        </TabsContent>
      </Tabs>
    </div>
  );
}
